import { Stack } from "@mui/material";
import { PaymentCard } from "./PaymentCard";
import { IPaymentCardSubscriptionType } from "../../../interfaces/payment/material/IPaymentCard";

export const PaymentCardsSection = () => {
  return (
    <Stack className="mt-[42px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 ">
      <PaymentCard
        title="Free"
        isFree
        subtitle="Start your journey"
        featuresList={[
          "Access a selection of workouts and content",
          "Create your own workouts & track your progress",
        ]}
      />

      <PaymentCard
        title="Bronze"
        subtitle="Unlock proven training plans"
        featuresList={[
          "Access to 2 training plans each month (1 active at a time, switch anytime)",
          "Access exclusive content (workouts, and more)",
          "Workout support & advice directly from Pod1um",
        ]}
        subscriptionType={IPaymentCardSubscriptionType.BRONZE}
      />

      <PaymentCard
        title="Silver"
        subtitle="More plans, more possibilities"
        featuresList={[
          "Access to 3 training plans each month (2 active at a time, switch anytime)",
          "Access exclusive content (workouts, and more)",
          "Workout support & advice directly from Pod1um",
        ]}
        subscriptionType={IPaymentCardSubscriptionType.SILVER}
        detachable
      />

      <PaymentCard
        title="Gold"
        subtitle="Elite coaching & support"
        featuresList={[
          "Access to 5 training plans each month (3 active at a time, switch anytime)",
          "Access exclusive content (workouts, and more)",
          "Premium support from Pod1um & plan creators",
          "Personalised guidance from training plan creators through direct messaging",
        ]}
        subscriptionType={IPaymentCardSubscriptionType.GOLD}
      />
    </Stack>
  );
};
